import { registerActivity } from "../../../registry";
import { WorkflowActivityDefinition } from "../../../types";

export const ChatbotSendMessage: WorkflowActivityDefinition = {
  group: 'chatbot',
  name: 'chatbot-send-message',
  type: 'activity',
  isFlowControl: true,
  schema: {
    type: 'object',
  },
  inputs: [
    {
      name: 'inFlow',
      type: 'flowControl',
    },
    {
      name: 'message',
      type: 'text',
    },
  ],
  outputs: [
    {
      name: 'inFlow',
      type: 'flowControl',
    },
    {
      name: 'message',
      type: 'text',
    },
  ],
};

registerActivity(ChatbotSendMessage);
